module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.count) ? _c('div', {
    staticClass: "bubble",
    class: _vm.color !== '' ? 'bubble--' + _vm.color : ''
  }, [_c('span', [_vm._v(_vm._s(_vm.count))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc95e5f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Bubble.vue
// module id = 502
// module chunks = 234